import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { apiRequest } from '../hooks/useApi.js'
import { useAnnouncer } from '../contexts/AnnouncerContext.jsx'

export default function StatsScreen() {
  const navigate = useNavigate()
  const { announce, alertSR } = useAnnouncer()
  const [stats, setStats] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false
    async function load() {
      try {
        const data = await apiRequest('GET', '/stats')
        if (!cancelled) {
          setStats(data)
          announce(`Estatísticas carregadas. ${data.wins} vitórias, ${data.losses} derrotas.`)
        }
      } catch (err) {
        if (!cancelled) {
          alertSR(`Erro ao carregar estatísticas: ${err.message}`)
        }
      } finally {
        if (!cancelled) setLoading(false)
      }
    }
    load()
    return () => { cancelled = true }
  }, [announce, alertSR])

  return (
    <section aria-labelledby="stats-heading">
      <h2 id="stats-heading">Estatísticas</h2>
      <div id="stats-content">
        {loading && <p>Carregando...</p>}
        {!loading && stats && (
          <>
            <p>Vitórias: <strong>{stats.wins}</strong></p>
            <p>Derrotas: <strong>{stats.losses}</strong></p>
            <p>Total de partidas: <strong>{stats.total_matches}</strong></p>
          </>
        )}
        {!loading && !stats && <p>Nenhuma estatística disponível.</p>}
      </div>
      <button type="button" className="btn btn-secondary" onClick={() => navigate('/menu')}>
        Voltar ao menu
      </button>
    </section>
  )
}
